import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useMemo } from 'react';
import GlobeAltIcon from '@heroicons/react/outline/GlobeAltIcon';
import { useDecision } from '@optimizely/react-sdk';
import { useAuthMember, useNetwork, useTranslateMarkup, } from '@tribeplatform/react-sdk/hooks';
import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons';
import { Link } from '@tribeplatform/react-ui-kit/Link';
import { FeaturesList } from '../common/constants/features';
import { T } from '../i18n';
import { getTranslatableFields, getTranslatedPost } from './utils/postTranslate';
export const PostTranslate = ({ post, fields: networkFields, onTranslate, }) => {
    var _a, _b, _c, _d;
    const [shouldTranslate, setShouldTranslate] = useState(false);
    const [decisionTranslateButton] = useDecision(FeaturesList.TranslateButton);
    const translatableFields = useMemo(() => getTranslatableFields(post === null || post === void 0 ? void 0 : post.fields, networkFields), [networkFields, post === null || post === void 0 ? void 0 : post.fields]);
    const { data: member } = useAuthMember();
    const { data: network } = useNetwork();
    const { data: translatedFieldsData, isLoading } = useTranslateMarkup({
        useQueryOptions: {
            enabled: shouldTranslate,
        },
        variables: {
            input: Object.values(translatableFields),
        },
    });
    const toggleTranslation = () => {
        if (isLoading) {
            return;
        }
        if (shouldTranslate) {
            onTranslate(null);
            setShouldTranslate(false);
            return;
        }
        setShouldTranslate(true);
    };
    useEffect(() => {
        if (shouldTranslate && translatedFieldsData) {
            const translatedPost = getTranslatedPost(post, translatedFieldsData, translatableFields);
            onTranslate(translatedPost);
        }
    }, [
        onTranslate,
        post,
        shouldTranslate,
        translatableFields,
        translatedFieldsData,
    ]);
    if (!decisionTranslateButton.enabled ||
        !((_b = (_a = network === null || network === void 0 ? void 0 : network.settings) === null || _a === void 0 ? void 0 : _a.contentTranslation) === null || _b === void 0 ? void 0 : _b.enabled)) {
        return null;
    }
    if (!(post === null || post === void 0 ? void 0 : post.language) ||
        (post === null || post === void 0 ? void 0 : post.language) === ((_d = (_c = member === null || member === void 0 ? void 0 : member.locale) === null || _c === void 0 ? void 0 : _c.split('-')) === null || _d === void 0 ? void 0 : _d[0]) ||
        Object.keys(translatableFields).length === 0) {
        return null;
    }
    return (_jsx("div", { className: "pt-2", children: _jsxs(Link, { variant: "inherit", className: "inline-flex space-s-1 items-center text-sm", onClick: toggleTranslation, children: [isLoading ? (_jsx(SpinnerIcon, { className: "animate-spin w-4 h-4" }, void 0)) : (_jsx(GlobeAltIcon, { className: "w-4 h-4" }, void 0)), _jsx("span", { children: !isLoading && shouldTranslate ? (_jsx(T, { id: "Post.PostTranslate.SeeOriginalLing", defaultMessage: "See original" }, void 0)) : (_jsx(T, { id: "Post.PostTranslate.SeeTranslationLink", defaultMessage: "See translation" }, void 0)) }, void 0)] }, void 0) }, void 0));
};
//# sourceMappingURL=PostTranslate.js.map